
const MwSwitch = ({onChangeSwitch,custKey,isActive,setIsActive,modern=false,label}) => {

    const onClickSwitch = () => {
        setIsActive(!isActive);
        onChangeSwitch({key:custKey , value:isActive})
    }

    if (modern) {
        return (
            <button
                type="button"
                role="switch"
                aria-checked={Boolean(isActive)}
                aria-label={label}
                onClick={onClickSwitch}
                className="mw-modern-switch"
            >
                <span className="mw-modern-switch-thumb" aria-hidden="true" />
            </button>
        );
    }

    return (
        <div 
            onClick={() => onClickSwitch()} 
            className={`relative flex h-4 w-12 rounded-lg ${isActive ? 'bg-green-500 justify-end' : 'bg-gray-200 dark:bg-slate-700' }`}>
            <div className='h-4 w-4 rounded-full bg-gray-300 dark:bg-slate-300'></div>
        </div>
    )
}

export default MwSwitch